<template>
  <!-- TOAST LOADING -->
  <div class="MIDAS-TOAST-loading" v-if="toastMsg">
    <p class="MIDAS-TOAST-loading__txt">{{ toastMsg }}</p>
  </div>
</template>
<script>
export default {
  name: "Toast",
  props: ["toastMsg"]
}
</script>

<style scoped>
.MIDAS-TOAST-loading {
  position: fixed;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  z-index: 1071;
  background-color: rgba(0, 0, 0, 0.8);
  padding: 1.5em 2em;
  color: #fff;
  font-size: 0.28rem;
  white-space: nowrap;
  border-radius: 0.5em;
}
.MIDAS-TOAST-loading__txt {
  line-height: 1;
  display: inline-block;
}
</style>
